import { FormField, FormFieldType, TranslationFunction } from '@/type';
import { emailValidator, requiredStringValidation } from '@/constant';
import * as yup from 'yup';

export const profileCommonDetailFormFields: FormField[] = [
  {
    type: FormFieldType.Typography,
    text: 'common.my-details',
    variant: 'h3',
  },
  {
    type: FormFieldType.Text,
    name: 'username',
    label: 'profile.username',
    xs: 6,
    disabled: true,
  },
  {
    type: FormFieldType.Text,
    name: 'lastName',
    label: 'profile.last-name',
    xs: 6,
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Text,
    name: 'firstName',
    label: 'profile.first-name',
    xs: 6,
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Text,
    name: 'email',
    label: 'profile.email',
    xs: 6,
    validation: emailValidator(),
  },
];

export const getProfileChangePasswordFormFields = (
  t: TranslationFunction,
): FormField[] => [
  {
    type: FormFieldType.Typography,
    text: 'profile.change-password',
    variant: 'h3',
  },
  {
    type: FormFieldType.Password,
    name: 'oldPassword',
    label: 'profile.old-password',
    xs: 12,
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Password,
    name: 'newPassword',
    label: 'profile.new-password',
    xs: 12,
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Password,
    name: 'confirmNewPassword',
    label: 'profile.confirm-new-password',
    xs: 12,
    validation: requiredStringValidation().oneOf(
      [yup.ref('newPassword'), null],
      t('validation.passwords_must_match'),
    ),
  },
];
